<ng-template>
  <div (click)="close()" class="dropdown">
    <ng-content></ng-content>
  </div>
</ng-template>
